import React, { useState } from "react";
import Highlight from "../Highlight";

const ITEMS = [
  {
    q: "How do you vet GTM talent?",
    a: "Three gates: a track-record review by a senior operator in the same function (real quotas, real pipeline numbers), a paid live work trial \u2014 SDRs run a real sequence, RevOps analysts rebuild a real funnel \u2014 and reference checks with two past clients or managers. Roughly 5 in 100 applicants make it through.",
  },
  {
    q: "What does it cost?",
    a: "Marketplace: you pay the freelancer's listed rate plus a flat 10% platform fee \u2014 no hidden markups. Managed engagements are scoped per outcome (e.g. meetings booked, funnel rebuilt) after a call.",
  },
  {
    q: "What if they don't perform?",
    a: "Tell us within 14 days and we replace them free. On managed engagements your account lead watches the numbers weekly \u2014 pipeline, response rates, data quality \u2014 and catches a mismatch before you have to.",
  },
  {
    q: "Will an SDR really sound like our team?",
    a: "Yes \u2014 every outbound hire onboards with your ICP, tone and objection playbook before the first email goes out. You approve the messaging; they keep it human. Same for lifecycle and CS: your voice, their hands.",
  },
  {
    q: "Who owns the work \u2014 and the data?",
    a: "You do. CRM records, sequences, dashboards, code \u2014 everything lives in your tools under your accounts. Full IP transfer on payment, NDA included by default.",
  },
  {
    q: "How fast can someone start?",
    a: "Marketplace hires typically start within the week. Managed engagements get a matched freelancer in 72 hours and a kickoff inside 5 business days.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="mx-auto max-w-[840px] px-6 py-24 lg:px-10">
      <h2 className="mb-11 text-balance text-[clamp(32px,4vw,48px)] font-bold leading-[1.05] tracking-[-0.025em]">
        Fair <Highlight>questions</Highlight>.
      </h2>

      <div className="flex flex-col gap-3">
        {ITEMS.map((it, i) => {
          const isOpen = open === i;
          return (
            <div
              key={it.q}
              className="overflow-hidden rounded-2xl border-[1.5px] border-ink-v2 bg-white"
            >
              <button
                type="button"
                aria-expanded={isOpen}
                onClick={() => setOpen(isOpen ? -1 : i)}
                className="flex w-full items-center justify-between gap-4 px-[26px] py-[22px] text-left text-[17px] font-bold leading-[1.3]"
              >
                {it.q}
                <span
                  aria-hidden="true"
                  className={`flex-none text-[22px] font-normal leading-none transition-transform duration-[220ms] ease-[cubic-bezier(0.22,1,0.36,1)] ${
                    isOpen ? "rotate-45" : ""
                  }`}
                >
                  +
                </span>
              </button>
              {/* 0fr -> 1fr animates the height without hard-coding one */}
              <div
                className="grid transition-[grid-template-rows] duration-[220ms] ease-[cubic-bezier(0.22,1,0.36,1)]"
                style={{ gridTemplateRows: isOpen ? "1fr" : "0fr" }}
              >
                <div className="overflow-hidden">
                  <p className="max-w-[640px] px-[26px] pb-6 text-[16px] leading-[1.55] text-warm-600">
                    {it.a}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
